/** Configuration navigation panel — source unique pour le menu latéral. */



import {

  canPanelAdminTier,

  canPanelManageInterventions,

  canPanelManagePremium,

  canPanelModeratePlayers,

  canPanelSystemCm,

  canPanelViewInterventionsCta,

} from '../panelAccess/panelRoleAccess';



export type PanelNavItemConfig = {

  to: string;

  label: string;

  section: string;

  defaultAccess: (roleId: number) => boolean;

  activePrefix?: string;

};



export type PanelNavGroupConfig = {

  id: string;

  label: string;

  items: PanelNavItemConfig[];

};



export type PanelSalonConfig = {

  id: string;

  label: string;

  subtitle: string;

  to: string;

  section: string;

  accent: 'amber' | 'sky' | 'yellow' | 'violet' | 'cyan';

  defaultAccess: (roleId: number) => boolean;

  loadingFallback: (roleId: number) => boolean;

};



export const PANEL_NAV_GROUPS: PanelNavGroupConfig[] = [

  {

    id: 'overview',

    label: 'Vue d’ensemble',

    items: [

      {

        to: '/panel/dashboard',

        label: 'Dashboard',

        section: 'stats',

        defaultAccess: (r) => r >= 1 && r <= 4,

        activePrefix: '/panel/dashboard',

      },

    ],

  },

  {

    id: 'players',

    label: 'Joueurs',

    items: [

      {

        to: '/panel/users-roles',

        label: 'Liste & comptes',

        section: 'salon_joueurs',

        defaultAccess: canPanelModeratePlayers,

        activePrefix: '/panel/users-roles',

      },

      {

        to: '/panel/users',

        label: 'Utilisateurs (détail)',

        section: 'admin',

        defaultAccess: canPanelAdminTier,

        activePrefix: '/panel/users',

      },

      {

        to: '/panel/players/premium',

        label: 'Statut premium (joueurs)',

        section: 'player_premium',

        defaultAccess: canPanelManagePremium,

        activePrefix: '/panel/players',

      },

      {

        to: '/panel/moderation',

        label: 'Modération',

        section: 'moderation',

        defaultAccess: canPanelModeratePlayers,

        activePrefix: '/panel/moderation',

      },

    ],

  },

  {

    id: 'interventions',

    label: 'Interventions',

    items: [

      {

        to: '/panel/cta',

        label: 'CTA — interventions',

        section: 'interventions',

        defaultAccess: canPanelViewInterventionsCta,

        activePrefix: '/panel/cta',

      },

      {

        to: '/panel/interventions/create',

        label: 'Créer un scénario',

        section: 'interventions_manage',

        defaultAccess: canPanelManageInterventions,

        activePrefix: '/panel/interventions/create',

      },

      {

        to: '/panel/interventions/manage',

        label: 'Gérer les scénarios',

        section: 'interventions_manage',

        defaultAccess: canPanelManageInterventions,

        activePrefix: '/panel/interventions/manage',

      },

      {

        to: '/panel/cta/categories-mission',

        label: 'Catégories mission',

        section: 'interventions_manage',

        defaultAccess: canPanelManageInterventions,

        activePrefix: '/panel/cta/categories-mission',

      },

    ],

  },

  {

    id: 'administration',

    label: 'Administration',

    items: [

      {

        to: '/panel/users/roles',

        label: 'Rôles utilisateurs',

        section: 'admin',

        defaultAccess: canPanelAdminTier,

        activePrefix: '/panel/users/roles',

      },

      {

        to: '/panel/roles/default-access',

        label: 'Accès par défaut (rôles)',

        section: 'admin',

        defaultAccess: canPanelAdminTier,

        activePrefix: '/panel/roles/default-access',

      },

      {

        to: '/panel/system/security-logs',

        label: 'Logs sécurité (complet)',

        section: 'salon_security',

        defaultAccess: canPanelAdminTier,

        activePrefix: '/panel/system/security-logs',

      },

      {

        to: '/panel/support/team',

        label: 'Tickets équipe',

        section: 'salon_ref',

        defaultAccess: (r) => r === 4 || r === 5,

        activePrefix: '/panel/support/team',

      },

    ],

  },

  {

    id: 'security',

    label: 'Sécurité',

    items: [

      {

        to: '/panel/security',

        label: 'Logs & traçabilité',

        section: 'salon_security',

        defaultAccess: canPanelModeratePlayers,

        activePrefix: '/panel/security',

      },

    ],

  },

  {

    id: 'system_cm',

    label: 'Système (CM)',

    items: [

      {

        to: '/panel/config',

        label: 'Configuration métier',

        section: 'system',

        defaultAccess: canPanelSystemCm,

        activePrefix: '/panel/config',

      },

      {

        to: '/panel/cm/maintenance',

        label: 'Maintenance',

        section: 'salon_cm',

        defaultAccess: canPanelSystemCm,

        activePrefix: '/panel/cm/maintenance',

      },

      {

        to: '/panel/system/backup',

        label: 'Sauvegardes',

        section: 'system',

        defaultAccess: canPanelSystemCm,

        activePrefix: '/panel/system/backup',

      },

      {

        to: '/panel/cm/referent',

        label: 'Référent CM',

        section: 'salon_cm',

        defaultAccess: canPanelSystemCm,

        activePrefix: '/panel/cm/referent',

      },

      {

        to: '/panel/roles/individual',

        label: 'Rôles individuels',

        section: 'roles',

        defaultAccess: canPanelSystemCm,

        activePrefix: '/panel/roles/individual',

      },

    ],

  },

];



export const PANEL_SALONS: PanelSalonConfig[] = [

  {

    id: 'cm',

    label: 'CM',

    subtitle: 'Tout le panel + système',

    to: '/panel/cm',

    section: 'salon_cm',

    accent: 'amber',

    defaultAccess: (r) => r === 1,

    loadingFallback: (r) => r === 1,

  },

  {

    id: 'admin',

    label: 'Administrateur',

    subtitle: 'Joueurs & statut premium (outil staff)',

    to: '/panel/admin',

    section: 'salon_admin',

    accent: 'sky',

    defaultAccess: (r) => r === 1 || r === 2,

    loadingFallback: (r) => r === 1 || r === 2,

  },

  {

    id: 'modo',

    label: 'Modérateur',

    subtitle: 'Surveillance & modération',

    to: '/panel/modo',

    section: 'salon_modo',

    accent: 'yellow',

    defaultAccess: (r) => r === 1 || r === 3,

    loadingFallback: (r) => r === 1 || r === 3,

  },

  {

    id: 'gr-scenarios',

    label: 'GR — Scénarios',

    subtitle: 'CTA, scénarios & missions (Groupe de réflexion)',

    to: '/panel/scenariste',

    section: 'salon_scenariste',

    accent: 'violet',

    defaultAccess: (r) => r === 1 || r === 4,

    loadingFallback: (r) => r === 1 || r === 4,

  },

  {

    id: 'referents',

    label: 'Référents',

    subtitle: 'Fonctions référent assignées',

    to: '/panel/ref',

    section: 'salon_ref',

    accent: 'cyan',

    defaultAccess: (r) => r === 4,

    loadingFallback: (r) => r === 4,

  },

];



export const ROLE_LABELS: Record<number, string> = {

  1: 'Community Manager',

  2: 'Administrateur',

  3: 'Modérateur',

  4: 'Groupe de réflexion',

  5: 'Créateur de contenu',

  6: 'Joueur',

};



export function resolvePageTitle(pathname: string): string {

  if (pathname.startsWith('/panel/cm/maintenance')) return 'Maintenance';

  if (pathname.startsWith('/panel/cm/referent')) return 'Référent CM';

  if (pathname.startsWith('/panel/cm')) return 'Espace CM';

  if (pathname.startsWith('/panel/admin')) return 'Espace administrateur';

  if (pathname.startsWith('/panel/modo')) return 'Espace modérateur';

  if (pathname.startsWith('/panel/scenariste')) return 'Espace GR — scénarios';

  if (pathname.startsWith('/panel/ref')) return 'Espace référent';

  if (pathname.startsWith('/panel/dashboard') || pathname === '/panel') return 'Dashboard';

  if (pathname.startsWith('/panel/players/premium')) return 'Statut premium (joueurs)';
  if (pathname.startsWith('/panel/support/team')) return 'Tickets équipe';
  if (pathname.startsWith('/panel/users/roles')) return 'Rôles utilisateurs';
  if (pathname.startsWith('/panel/roles/default-access')) return 'Accès par défaut (rôles)';
  if (pathname.startsWith('/panel/roles/individual')) return 'Rôles individuels';
  if (pathname.startsWith('/panel/users')) return 'Utilisateurs (détail)';

  if (pathname.startsWith('/panel/moderation/manage')) return 'Gestion joueur';

  if (pathname.startsWith('/panel/interventions/create')) return 'Créer un scénario';

  if (pathname.startsWith('/panel/interventions/manage')) return 'Gérer les scénarios';

  if (pathname.startsWith('/panel/interventions/edit')) return 'Modifier scénario';

  if (pathname.startsWith('/panel/cta/categories-mission')) return 'Catégories mission';

  for (const group of PANEL_NAV_GROUPS) {

    for (const item of group.items) {

      const prefix = item.activePrefix || item.to;

      if (pathname === item.to || pathname.startsWith(`${prefix}/`)) return item.label;

    }

  }

  return 'Panel';

}


